import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://gallopai.app';

type GuideSeoProps = {
  segment: string;
  title: string;
  description: string;
};

export const GuideSeo: React.FC<GuideSeoProps> = ({ segment, title, description }) => {
  const url = `${SITE}/guide/${segment}`;
  const pageTitle = `${title} | GallopAI User Guide`;
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};
